/*
 * Moment date formatting filter
 *  - Like Angular 'date' but for moments
 *
 * Angular Module: "trackerbase-app.filters.moment-format-date-filter"
 * Filter exposed as: tbMomentDate
 *
 */
import moment from "moment-timezone";
import angular from "angular";

function momentFormatDateFilterFactory($log) {

    function momentFormatDateFilter(momentDate, momentFormat) {
        if (!moment.isMoment(momentDate)) {
            return undefined;
        }

        if (!angular.isString(momentFormat)) {
            $log.debug("Moment Format Date Filter: Invalid Format String");
            return undefined;
        }

        let formattedDate = momentDate.format(momentFormat);
        return formattedDate;
    }

    return momentFormatDateFilter;
}

momentFormatDateFilterFactory.$inject = [ "$log" ];

export default angular
    .module("trackerbase-app.filters.moment-format-date-filter", [
    ])
    .filter("tbMomentDate",momentFormatDateFilterFactory)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/filters/MomentFormatDateFilter.js
// module id = lfpa
// module chunks = 1